import type React from 'react';
import type { JSX } from 'react';
import { Tooltip } from '@mui/material';
import { ErrorCriteriaIcon, SuccessCriteriaIcon, WarningCriteriaIcon } from '../../box-containers/boxContainers';

interface Props {
  title: string | Array<{ text: string; icon?: 'success' | 'error' | 'warning' }> | undefined;
  children: React.ReactElement;
  open?: boolean;
}

export const CriteriaTooltip = ({ title, open, children }: Props): JSX.Element => {
  return (
    <Tooltip
      title={
        Array.isArray(title)
          ? title.map((val, index) => {
              return (
                <div key={'tooltipLine' + index}>
                  {val.icon === 'success' ? (
                    <SuccessCriteriaIcon color={'success'} fontSize={'small'} className={'criteria'} />
                  ) : val.icon === 'warning' ? (
                    <WarningCriteriaIcon color={'warning'} fontSize={'small'} className={'criteria'} />
                  ) : val.icon === 'error' ? (
                    <ErrorCriteriaIcon color={'error'} fontSize={'small'} className={'criteria'} />
                  ) : null}
                  &ensp;{val.text}
                </div>
              );
            })
          : title
      }
      placement={'top'}
      arrow={true}
      open={open}
    >
      {children}
    </Tooltip>
  );
};
